(function () {
  function init(root) {
    var gal = root.querySelector('[data-lx-gal]');
    if (!gal || gal.dataset.galleryBound) return;
    var track = gal.querySelector('[data-lx-track]');
    var slides = Array.from(gal.querySelectorAll('[data-lx-slide]'));
    if (!track || !slides.length) return;
    gal.dataset.galleryBound = 'true';
    var thumbs = Array.from(gal.querySelectorAll('[data-lx-thumb]'));
    var row = gal.querySelector('[data-lx-thumbs]');
    var previous = gal.querySelector('[data-lx-step="-1"]');
    var next = gal.querySelector('[data-lx-step="1"]');
    var live = gal.querySelector('[data-lx-gal-live]');
    var reduced = matchMedia('(prefers-reduced-motion: reduce)');
    var active = -1, target = 0, frame = 0, settleTimer = 0;
    var navigating = false, drag = null, suppressClick = false;
    var ready = [];
    function width() { return track.getBoundingClientRect().width || 1; }
    function clamp(n) { return Math.max(0, Math.min(slides.length - 1, n)); }
    function warm(n) {
      if (n < 0 || n >= slides.length || ready[n]) return;
      ready[n] = true;
      slides[n].loading = 'eager';
      if (slides[n].decode) slides[n].decode().catch(function () {});
    }
    function syncThumb(n) {
      var thumb = thumbs[n];
      if (!row || !thumb || row.scrollWidth <= row.clientWidth) return;
      var r = row.getBoundingClientRect(), t = thumb.getBoundingClientRect();
      var left = row.scrollLeft;
      if (t.left < r.left) left += t.left - r.left;
      else if (t.right > r.right) left += t.right - r.right;
      if (left !== row.scrollLeft) row.scrollTo({ left: left, behavior: reduced.matches ? 'instant' : 'smooth' });
    }
    function show(n, announce) {
      n = clamp(n);
      if (active === n) return;
      active = n;
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-on', i === n);
        if (i === n) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      var tone = slides[n].parentElement.getAttribute('data-tone') || '';
      gal.toggleAttribute('data-tone-l', tone.includes('l'));
      gal.toggleAttribute('data-tone-r', tone.includes('r'));
      if (previous) previous.disabled = n === 0;
      if (next) next.disabled = n === slides.length - 1;
      if (announce && live) live.textContent = 'Image ' + (n + 1) + ' of ' + slides.length;
      syncThumb(n);
      warm(n); warm(n - 1); warm(n + 1);
    }
    function finish() {
      clearTimeout(settleTimer);
      if (drag) return;
      if (navigating && Math.abs(track.scrollLeft - target * width()) > 1.5) {
        settleTimer = setTimeout(finish, 160);
        return;
      }
      navigating = false;
      target = clamp(Math.round(track.scrollLeft / width()));
      show(target, true);
    }
    function go(n, instant) {
      target = clamp(n);
      navigating = true;
      warm(target);
      show(target, true);
      track.scrollTo({ left: target * width(), behavior: instant || reduced.matches ? 'instant' : 'smooth' });
      clearTimeout(settleTimer);
      settleTimer = setTimeout(finish, 160);
    }
    track.addEventListener('scroll', function () {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(finish, 160);
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = 0;
        var n = clamp(Math.round(track.scrollLeft / width()));
        if (!navigating) target = n;
        show(n, false);
      });
    }, { passive: true });
    track.addEventListener('scrollend', finish);
    track.addEventListener('pointerdown', function (event) {
      if (event.button > 0) return;
      track.scrollTo({ left: track.scrollLeft, behavior: 'instant' });
      navigating = false;
      target = clamp(Math.round(track.scrollLeft / width()));
      if (event.pointerType !== 'mouse') return;
      drag = { id: event.pointerId, start: event.clientX, left: track.scrollLeft, moved: false };
    });
    track.addEventListener('wheel', function () { navigating = false; }, { passive: true });
    track.addEventListener('pointermove', function (event) {
      if (!drag || drag.id !== event.pointerId) return;
      var dx = event.clientX - drag.start;
      if (!drag.moved && Math.abs(dx) < 5) return;
      if (!drag.moved) {
        drag.moved = true;
        track.classList.add('is-drag');
        track.setPointerCapture(event.pointerId);
      }
      event.preventDefault();
      track.scrollLeft = drag.left - dx;
    });
    function release(event) {
      if (!drag || drag.id !== event.pointerId) return;
      var moved = drag.moved;
      drag = null;
      track.classList.remove('is-drag');
      if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      if (moved) {
        suppressClick = true;
        setTimeout(function () { suppressClick = false; }, 0);
        go(Math.round(track.scrollLeft / width()));
      }
    }
    track.addEventListener('pointerup', release);
    track.addEventListener('pointercancel', release);
    track.addEventListener('lostpointercapture', release);
    track.addEventListener('pointerleave', function (event) { if (drag && !drag.moved) release(event); });
    track.addEventListener('click', function (event) { if (suppressClick) event.preventDefault(); }, true);
    gal.addEventListener('keydown', function (event) {
      if (!event.target.closest('[data-lx-track],[data-lx-thumb],[data-lx-step]')) return;
      var n;
      if (event.key === 'ArrowLeft') n = target - 1;
      else if (event.key === 'ArrowRight') n = target + 1;
      else if (event.key === 'Home') n = 0;
      else if (event.key === 'End') n = slides.length - 1;
      else return;
      event.preventDefault();
      go(n);
      if (event.target.hasAttribute('data-lx-thumb')) thumbs[target].focus({ preventScroll: true });
    });
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { go(i); });
      thumb.addEventListener('pointerenter', function () { warm(i); });
    });
    gal.querySelectorAll('[data-lx-step]').forEach(function (button) {
      button.addEventListener('click', function () { go(target + Number(button.getAttribute('data-lx-step'))); });
    });
    var lastWidth = width();
    var observer = new ResizeObserver(function () {
      if (width() === lastWidth) return;
      lastWidth = width();
      go(target, true);
    });
    observer.observe(track);
    function cleanup(event) {
      if (!event.target.contains(gal)) return;
      observer.disconnect();
      clearTimeout(settleTimer);
      cancelAnimationFrame(frame);
      document.removeEventListener('shopify:section:unload', cleanup);
    }
    document.addEventListener('shopify:section:unload', cleanup);
    show(0, false);
  }
  var root = document.getElementById('hp-lrx');
  if (root) init(root);
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('#hp-lrx');
    if (root) init(root);
  });
})();
